var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPrivacy = function SvgPrivacy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53.166,
    height: 64.18,
    viewBox: "0 0 53.166 64.18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_hands_430101",
    transform: "translate(-16.811 -5.693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16716",
    "data-name": "Group 16716",
    transform: "translate(16.81 41.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16700",
    "data-name": "Group 16700",
    transform: "translate(4.693 1.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10059",
    "data-name": "Path 10059",
    d: "M36.948,71.758l-.145-.144c-.1-.1-9.734-9.718-14.137-12.046a.331.331,0,0,1,.31-.584c4.248,2.246,12.893,10.77,14.154,12.022a21.7,21.7,0,0,1,3.733-.708.33.33,0,0,1,.071.657,20.261,20.261,0,0,0-3.791.739Z",
    transform: "translate(-22.49 -58.946)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16701",
    "data-name": "Group 16701",
    transform: "translate(22.064 12.448)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10060",
    "data-name": "Path 10060",
    d: "M44.7,73.342a.33.33,0,0,1-.039-.658l.04.329-.03-.329.045-.007a.331.331,0,0,1,.067.658l-.041,0A.366.366,0,0,1,44.7,73.342Z",
    transform: "translate(-44.369 -72.676)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16702",
    "data-name": "Group 16702",
    transform: "translate(0 0.523)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10061",
    "data-name": "Path 10061",
    d: "M40.294,79.214c-3.588,0-6.566-.195-7.68-.762-1.791-.91-15.33-15.009-15.671-15.793a4.133,4.133,0,0,1,.678-3.466,2.9,2.9,0,0,1,3.092-.839,5.194,5.194,0,0,1,1.272.508.33.33,0,1,1-.308.584A4.651,4.651,0,0,0,20.573,59a2.294,2.294,0,0,0-2.441.613,3.638,3.638,0,0,0-.591,2.766c.6.865,13.55,14.559,15.372,15.485,3.368,1.714,26.245-.271,26.474-.291a.327.327,0,0,1,.359.3.331.331,0,0,1-.3.359C58.8,78.288,48.1,79.214,40.294,79.214Z",
    transform: "translate(-16.81 -58.243)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16703",
    "data-name": "Group 16703",
    transform: "translate(14.923 5.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10062",
    "data-name": "Path 10062",
    d: "M41.957,70.586a.331.331,0,0,1-.226-.09c-1.243-1.177-4.467-4.128-6.092-5.545a.33.33,0,1,1,.434-.5c1.631,1.422,4.866,4.383,6.112,5.562a.331.331,0,0,1-.227.571Z",
    transform: "translate(-35.525 -64.371)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16704",
    "data-name": "Group 16704",
    transform: "translate(9.538 1.199)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10063",
    "data-name": "Path 10063",
    d: "M34.68,64.108a.335.335,0,0,1-.217-.081,52.464,52.464,0,0,0-5.545-4.358.33.33,0,1,1,.359-.555A53.36,53.36,0,0,1,34.9,63.529a.33.33,0,0,1-.217.579Z",
    transform: "translate(-28.767 -59.061)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16705",
    "data-name": "Group 16705",
    transform: "translate(4.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10064",
    "data-name": "Path 10064",
    d: "M28.006,59.47a.333.333,0,0,1-.179-.053,7.414,7.414,0,0,0-2.118-1.049,2.228,2.228,0,0,0-2.61.852.33.33,0,0,1-.56-.35,2.824,2.824,0,0,1,3.311-1.148,7.807,7.807,0,0,1,2.334,1.139.33.33,0,0,1,.1.457A.325.325,0,0,1,28.006,59.47Z",
    transform: "translate(-22.489 -57.61)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16706",
    "data-name": "Group 16706",
    transform: "translate(21.362 8.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10065",
    "data-name": "Path 10065",
    d: "M43.489,68.013l.428-.5-.139.168.154-.154-.226.24Z",
    transform: "translate(-43.489 -67.51)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16707",
    "data-name": "Group 16707",
    transform: "translate(16.096 3.55)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10066",
    "data-name": "Path 10066",
    d: "M42.567,67.115a.334.334,0,0,1-.221-.086c-.948-.853-4.289-3.758-5.241-4.538a.331.331,0,0,1,.418-.512c.981.8,4.286,3.677,5.265,4.559a.33.33,0,0,1,.025.466A.324.324,0,0,1,42.567,67.115Z",
    transform: "translate(-36.983 -61.906)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16708",
    "data-name": "Group 16708",
    transform: "translate(9.528 0.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10067",
    "data-name": "Path 10067",
    d: "M35.885,61.931a.329.329,0,0,1-.209-.076C33.042,59.7,31.821,59.1,31.26,58.978a1.791,1.791,0,0,0-1.907.479.331.331,0,0,1-.514-.416,2.386,2.386,0,0,1,2.561-.708c.929.2,2.465,1.189,4.693,3.012a.33.33,0,0,1-.208.587Z",
    transform: "translate(-28.766 -58.242)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16709",
    "data-name": "Group 16709",
    transform: "translate(22.231 7.184)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10068",
    "data-name": "Path 10068",
    d: "M44.908,66.968a.323.323,0,0,1-.231-.1l0,0a.326.326,0,1,1,.234.1Z",
    transform: "translate(-44.578 -66.305)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16710",
    "data-name": "Group 16710",
    transform: "translate(16.084 3.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10069",
    "data-name": "Path 10069",
    d: "M43.589,66.158a.332.332,0,0,1-.238-.1c-.031-.032-3.1-3.2-4.537-3.645a1.825,1.825,0,0,0-1.361.083.33.33,0,1,1-.277-.6,2.5,2.5,0,0,1,1.833-.113c1.6.492,4.687,3.681,4.817,3.816a.33.33,0,0,1-.008.468A.338.338,0,0,1,43.589,66.158Z",
    transform: "translate(-36.984 -61.66)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16711",
    "data-name": "Group 16711",
    transform: "translate(21.855 12.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10070",
    "data-name": "Path 10070",
    d: "M52.707,74.068a51.778,51.778,0,0,1-7.462-.571,1.758,1.758,0,0,1-.691-.188.33.33,0,1,1,.29-.592,1.1,1.1,0,0,0,.443.12l.036,0a40.073,40.073,0,0,0,11.693.292.33.33,0,1,1,.115.65A27.8,27.8,0,0,1,52.707,74.068Z",
    transform: "translate(-44.369 -72.683)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16712",
    "data-name": "Group 16712",
    transform: "translate(20.67 8.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10071",
    "data-name": "Path 10071",
    d: "M44.4,72.427a.315.315,0,0,1-.145-.034,3.086,3.086,0,0,1-1.494-2,3.392,3.392,0,0,1,.514-2.832l.026-.031a.33.33,0,1,1,.5.429l-.251-.215.251.215a2.731,2.731,0,0,0-.4,2.269A2.453,2.453,0,0,0,44.545,71.8a.33.33,0,0,1-.145.627Z",
    transform: "translate(-42.649 -67.409)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16713",
    "data-name": "Group 16713",
    transform: "translate(21.229 7.187)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10072",
    "data-name": "Path 10072",
    d: "M43.672,67.88a.318.318,0,0,1-.2-.066.33.33,0,0,1-.07-.462,4.082,4.082,0,0,1,1.1-.992.331.331,0,0,1,.357.557,3.416,3.416,0,0,0-.922.83A.333.333,0,0,1,43.672,67.88Z",
    transform: "translate(-43.342 -66.308)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16714",
    "data-name": "Group 16714",
    transform: "translate(22.225 7.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10073",
    "data-name": "Path 10073",
    d: "M44.9,66.969a.333.333,0,0,1-.321-.24.329.329,0,0,1,.226-.406l.1.315.074.323-.074-.323.08.321A.309.309,0,0,1,44.9,66.969Z",
    transform: "translate(-44.566 -66.322)",
    fill: "#07a3c8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16715",
    "data-name": "Group 16715",
    transform: "translate(21.263 5.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10074",
    "data-name": "Path 10074",
    d: "M59.556,87.411l.073-.392a14.608,14.608,0,0,0-.406-7.609.33.33,0,0,1,.608-.256,14.747,14.747,0,0,1,.515,7.594l15.417-.036c-1.1-13.424-2.753-16.932-2.769-16.966l-.022-.058c-.056-.2-1.49-4.932-8.164-4.932-12.953,0-19.539,1.738-19.813,1.812a.33.33,0,1,1-.172-.637c.278-.076,6.945-1.837,19.985-1.837,6.9,0,8.648,4.935,8.792,5.382.169.363,1.778,4.091,2.853,17.54l.027.357Z",
    transform: "translate(-44.577 -64.095)",
    fill: "#07a3c8"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_10075",
    "data-name": "Path 10075",
    d: "M59.874,33.705c-1.183-.364-3.469-2.578-4.26-3.368a4.02,4.02,0,0,0,.542-.486c1.034.919,3.339,2.921,4.534,3.929A1.888,1.888,0,0,1,59.874,33.705Z",
    transform: "translate(-7.825 -5.408)",
    fill: "#07a3c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10076",
    "data-name": "Path 10076",
    d: "M56.75,28.776a3.36,3.36,0,0,0,.455-2.032c1.507,1.4,3.989,3.666,5.354,4.855a57.154,57.154,0,0,0,5.275,4.184A1.954,1.954,0,0,1,66.2,36c-.559-.121-1.769-.714-4.38-2.841a.093.093,0,0,0-.036-.03c0-.007-.007-.01-.01-.007a.067.067,0,0,0-.027-.023C60.822,32.336,57.9,29.8,56.75,28.776Z",
    transform: "translate(-8.207 -4.804)",
    fill: "#07a3c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10077",
    "data-name": "Path 10077",
    d: "M72.966,35.379a2.316,2.316,0,0,1-2.4.572A7.367,7.367,0,0,1,68.445,34.9,52.768,52.768,0,0,1,62.9,30.545c-1.63-1.418-4.852-4.369-6.095-5.546a.337.337,0,0,0-.036-.03,3.269,3.269,0,0,0-.56-.82,20.39,20.39,0,0,0,2.932-.6C60.371,24.764,68.614,32.89,72.966,35.379Z",
    transform: "translate(-8.526 -4.127)",
    fill: "#07a3c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10078",
    "data-name": "Path 10078",
    d: "M69.365,28.844a3.7,3.7,0,0,1-.572,2.753,2.176,2.176,0,0,1-2.366.612,4.423,4.423,0,0,1-1.041-.431s0,0-.006,0a.071.071,0,0,0-.022-.01h0c-4.264-2.325-13.6-11.907-13.688-12l-.141-.145-.189.066a19,19,0,0,1-3.588.724,1.625,1.625,0,0,0-.577-.142,38.387,38.387,0,0,0-11.514-.286.33.33,0,0,0-.259.382.319.319,0,0,0,.371.267,37.8,37.8,0,0,1,11.325.293l.036,0a.9.9,0,0,1,.3.063.313.313,0,0,0,.2.092,2.484,2.484,0,0,1,1.044,1.531,2.8,2.8,0,0,1-.382,2.252s0,.007-.006.01-.01.013-.016.02l-.02.03a3.453,3.453,0,0,1-.831.768.011.011,0,0,0-.006,0c-.644.175-7.02,1.795-19.149,1.795-6.463,0-7.853-4.715-7.907-4.916l-.022-.056c-.016-.033-1.619-3.53-2.683-16.9l14.933-.036a16.031,16.031,0,0,0,.351,7.136c-2.311.171-3.918.316-4.154.336a.328.328,0,0,0-.291.359.319.319,0,0,0,.346.3c.064-.007,1.883-.168,4.533-.359a.086.086,0,0,0,.029,0,.191.191,0,0,0,.045,0c6.732-.481,18.71-1.143,21.041.076C56.237,14.335,68.779,27.981,69.365,28.844Z",
    transform: "translate(-0.145 0.117)",
    fill: "#07a3c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10079",
    "data-name": "Path 10079",
    d: "M48.837,42.1l-.7.7-.7-.7a4.737,4.737,0,0,0-6.7,6.7l.7.7,6.7,6.7,6.7-6.7.7-.7a4.737,4.737,0,1,0-6.7-6.7Z",
    transform: "translate(-4.756 -11.502)",
    fill: "#07a3c8"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrivacy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/privacy.7ea559d5.svg";
export { ForwardRef as ReactComponent };